import React from 'react'

const Box = (props) => {
    return (
        <>
                 <div className="col-md-4">
                     <div className="seo-box p-3 rounded project">

           <h3 className="step font-weight-bold mt-4">{props.step}</h3>
           <h3 className="text-primary">{props.head}</h3>
           <p className='text-justify'>{props.para}</p>
           </div>

    </div>
        </>
    )
}

export default Box
